import ContactList from "@/components/ContactList";

export default function Customers() {
  return (
    <ContactList
      title="Customers"
      eyebrow="Outbound · Trading partners"
      resource="customers"
      testPrefix="customer"
    />
  );
}
